import { BaseComponent } from "../shared/extends-components/base-component";

export class BaseSection {
  typeLoadFiles: number = -1;
  // realiza el efecto visual presionado
  _toggleOption: number = 2;

  constructor() {

  }

  /**
   * @author Jose Wilson Mulato
   * @description Valida los componentes si esta correcto
   * @param components
   */
  ValidFields(components: BaseComponent[]) {
    let isValid: boolean = true;
    components.forEach(comp => {
      let validComp: boolean = comp.Valid();
      isValid = isValid && validComp;
    });
    return isValid;
  }

  /**
   * @author Jose Wilson Mulato
   * @description Bloquea los componentes para que no sea editable
   */
  IsLockSection(components: BaseComponent[]) {
    components.forEach(c => c.SetDisable(true));
  }

  /**
   * @author John Nelson Rodríguez
   * @description Desbloquea los componentes para que sean editables
   */
  UnLockSection(components: BaseComponent[]) {
    components.forEach(c => c.SetDisable(false));
  }
}



// WEBPACK FOOTER //
// ./src/app/extends/base-section.ts